export const foreground = "#f3f4f6";
export const background = "#1f2937";
export const button = "rgb(59 130 246)";
export const buttonHover = "rgb(59 130 246 / 50%)";
